import { render, staticRenderFns } from "./PublicQuotationPages17.vue?vue&type=template&id=01d580b4&scoped=true&"
import script from "./PublicQuotationPages17.vue?vue&type=script&lang=js&"
export * from "./PublicQuotationPages17.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d580b4",
  null
  
)

export default component.exports